module.exports = __webpack_public_path__ + "static/media/warning-icon.55a15434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/warning-icon.svg
// module id = 324
// module chunks = 0